import { useMooConfig } from '../../provider';
import { ArrowUpRightFromSquareIcon } from './icons';
import { STUDIO_AVATAR_AGENT } from './studio-avatar';
import styles from './ShellDrawer.module.css';

/** Optional "Open Moo Studio" row. Renders only when
 *  `config.navigation.openStudio` is supplied by the host. Leads with Studio's
 *  mark from the host's avatar slot (see STUDIO_AVATAR_CATEGORY), at the
 *  agent tiles' size and in line with them. */
export function StudioLinkRow() {
  const { navigation, renderAgentAvatar } = useMooConfig();
  const onClick = navigation.openStudio;
  if (!onClick) return null;
  const mark = renderAgentAvatar?.(STUDIO_AVATAR_AGENT, { size: 'md' });
  return (
    <button type="button" className={styles.studioRow} onClick={onClick}>
      {mark ? (
        <span className={styles.studioRowMark} aria-hidden>
          {mark}
        </span>
      ) : null}
      <span className={styles.studioRowLabel}>Open Moo Studio</span>
      <span className={styles.studioRowIcon} aria-hidden>
        <ArrowUpRightFromSquareIcon />
      </span>
    </button>
  );
}
